module.exports = __webpack_public_path__ + "static/media/b-step1.f4190d09.png";